import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile } from "@/utils/responsive";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/about",
    // component: () => import('@/views/about/index.vue'),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
    // component: () => import('@/views/about/index.vue'),
  },
  {
    path: "/growthCare",
    name: "GrowthCare",
    component: () => import("@/views/GrowthCare.vue"),
    // component: () => import('@/views/growthCare/index.vue'),
  },
  {
    path: "/companyCulture",
    name: "CompanyCulture",
    component: () => import("@/views/CompanyCulture.vue"),
    // component: () => import('@/views/companyCulture/index.vue'),
  },
  {
    path: "/jobVacancy",
    name: "JobVacancy",
    component: () => import("@/views/JobVacancy.vue"),
    // component: () => import('@/views/jobVacancy/index.vue'),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      /*
       * 锚点跳转方法1：Router标准写法（依赖Router的内部的锚点跳转机制实现、部分浏览器或复杂布局不稳定）
       * return { selector: to.hash, behavior: "smooth" };
       * 优缺点：立即执行，没有延迟、可能在页面DOM还未完全渲染时执行、可能导致滚动位置不准确、如果锚点元素不存在，Router会静默失败
       * 适用环境：简单的锚点跳转、没有固定头部、标准布局页面
       */
      // -------------------------------------------------------------
      /*
       * 锚点跳转方法2：使用原生Web API手动实现、兼容移动端
       * 优缺点：自己加延迟，确保页面完全渲染、可以检查元素是否存在（更安全的错误处理）
       * 适用环境：有固定头部/导航栏、需要精确控制滚动位置、响应式设计（不同设备不同偏移量）、复杂布局页面
       * 解决方案：解决了固定头部遮挡问题、支持响应式设计、更好的兼容性
       */
      // 锚点跳转方法2：--------------------------------------start
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          // 只有当元素存在时才执行滚动
          if (element) {
            const headerOffset = isMobile() ? 58 : 64; // 移动端导航高度为：58px，PC端导航高度为：64px
            // 计算元素相对于视口的位置
            const rect = element.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            // const targetPosition = scrollTop + rect.top - 20; // 减去 header为了下滑隐藏上滑显示的效果加了固定定位，导致pc和移动端有一个导航高度的偏移量
            const targetPosition = scrollTop + rect.top - headerOffset;
            // 使用scrollTo进行平滑滚动
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          }
          resolve();
        }, 150); // 增加延迟确保页面完全加载
      });
      // 锚点跳转方法2：--------------------------------------end
    } else if (from.path === to.path) {
      return false;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
